<div *ngIf="isCompanyMenuAvailable">
  <div class="button" (click)="toggleMenu()">
    <span class="logo-plate opacity_button">
      <svg-icon [src]="logo" svgClass="logo"></svg-icon>
    </span>
    <nb-icon class="logo__arrow" icon="arrow-ios-downward-outline"></nb-icon>
  </div>

  <app-credits-bar
    *ngIf="credits?.enabled"
    class="opacity_button"
    [credits]="credits"
    (click)="toggleCreditsRequestDropdown()"
  ></app-credits-bar>
</div>

<div *ngIf="!isCompanyMenuAvailable">
  <span class="logo-plate">
    <svg-icon [src]="logo" svgClass="logo"></svg-icon>
  </span>
  <app-credits-bar
    *ngIf="credits?.enabled"
    class="opacity_button"
    [credits]="credits"
    (click)="toggleCreditsRequestDropdown()"
  ></app-credits-bar>
</div>
